import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, inject } from '@angular/core';
import { provideComponentStore } from '@ngrx/component-store';
import { ModalContainerComponent } from '@shared-lib/components/modal-container/modal-container.component';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InfoDialogStore } from './info-dialog.store';

export interface InfoDialogDataModel {
  header: string;
  text?: string;
  customTemplate?: TemplateRef<unknown>;
}

@Component({
  selector: 'cui-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, ModalContainerComponent, NgTemplateOutlet, AsyncPipe],
  providers: [provideComponentStore(InfoDialogStore)],
})
export class InfoDialogComponent implements AfterViewInit {
  private readonly dynamicDialogConfig: DynamicDialogConfig<InfoDialogDataModel> = inject(DynamicDialogConfig);
  private readonly componentStore = inject(InfoDialogStore);

  protected readonly isDialogPositionUp$ = this.componentStore.isDialogPositionUp$;

  protected readonly dialogData = this.dynamicDialogConfig.data;

  ngAfterViewInit(): void {
    this.componentStore.moveDialogUp();
  }

  protected close(): void {
    this.componentStore.closeDialog();
  }
}
